import { render } from "./InstallPrompt.vue?vue&type=template&id=380fbeed"
import script from "./InstallPrompt.vue?vue&type=script&lang=js"
export * from "./InstallPrompt.vue?vue&type=script&lang=js"
script.render = render

export default script